import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const channels = [
  {
    title: 'Customer Support',
    description: 'Questions about bookings, payments, account issues, or general platform help.',
    email: 'support@employmeglobal.com',
    phone: '+234 700 633 7665'
  }
]

const ContactUs = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' })
  const [status, setStatus] = useState('')

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!form.name || !form.email || !form.message) {
      setStatus('Please fill out all fields before sending your message.')
      return
    }
    setStatus('Thanks for reaching out. Our team will respond within 1-2 business days.')
    setForm({ name: '', email: '', message: '' })
  }

  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-5xl">
        <div className="mb-10">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-gray-600 hover:text-gray-900">
            <svg className="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
            </svg>
            Back to Home
          </Link>
        </div>

        <div className="rounded-2xl bg-white p-8 shadow-lg">
          <div className="mb-10 text-center">
            <h1 className="text-3xl font-bold text-gray-900">Contact Employ Me</h1>
            <p className="mt-3 text-base text-gray-600">
              We’re here to help you succeed on Employ Me. Reach our customer support team below or drop us a
              message and we’ll get back to you soon.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-1">
            {channels.map(channel => (
              <div key={channel.title} className="rounded-xl border border-gray-200 p-5">
                <h3 className="text-lg font-semibold text-gray-900">{channel.title}</h3>
                <p className="mt-2 text-sm text-gray-600">{channel.description}</p>
                <div className="mt-4 space-y-1 text-sm text-gray-800">
                  <a href={`mailto:${channel.email}`} className="block text-blue-600 hover:underline">
                    {channel.email}
                  </a>
                  <p>{channel.phone}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <div className="max-w-2xl">
              <h2 className="text-xl font-semibold text-gray-900">Send us a message</h2>
              <p className="mt-2 text-sm text-gray-600">
                Fill out the form and the appropriate team will follow up with you.
              </p>
              <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                <div>
                  <label htmlFor="name" className="mb-1 block text-sm font-medium text-gray-700">Full Name</label>
                  <input
                    id="name"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    className="w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-black focus:ring-black"
                    placeholder="Jane Doe"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="mb-1 block text-sm font-medium text-gray-700">Email</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    className="w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-black focus:ring-black"
                    placeholder="jane@example.com"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="mb-1 block text-sm font-medium text-gray-700">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    value={form.message}
                    onChange={handleChange}
                    className="w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-black focus:ring-black"
                    placeholder="Tell us how we can help..."
                  ></textarea>
                </div>
                {status && (
                  <p className="text-sm font-semibold text-blue-600">{status}</p>
                )}
                <button
                  type="submit"
                  className="w-full rounded-lg bg-[#00A5E6] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#008FCC]"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactUs


